// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"BP-z","inlineTitle":"CP-z","sponsoredAdsWrapper":"DP-z","marketplaceRecosWrapper":"EP-z"};